import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PostedOrders from "./PostedOrders/PostedOrders";
import PurchasedOrders from "./PurchasedOrders/PurchasedOrders";
import CompletedOrder from "./CompletedOrder/CompletedOrder";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../../redux/posts/action";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CancelledOrder from "./CancelledOrder/CancelledOrder";

export default function MyOrders() {
  const path = "Assets/scss/postproject.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { urlstate, setMyOrderroute, resetAllFields } = useRouteBaseStateContext();
  const [activeTab, setActiveTab] = useState("MyOrderPostedorders");
  const dispatch = useDispatch();
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);

  useEffect(() => {
    dispatch(getPostCounts(2));
  }, [dispatch]);

  function sumOrders(orderType) {
    const orders = postcounts[orderType];
    if (!orders) {
      console.error(`Order type ${orderType} not found`);
      return 0;
    }
    return Object.values(orders).reduce(
      (total, num) => total + parseInt(num, 10),
      0,
    );
  }

  const postedOrdersCount = sumOrders("posted_orders");
  const purchasedOrdersCount = sumOrders("purchased_orders");
  const completedOrdersCount = sumOrders("completed_orders");
  const cancelledOrdersCount = sumOrders("cancelled_orders");

  useEffect(() => {
    if (urlstate?.myorderroute) {
      setActiveTab(urlstate?.myorderroute || "MyOrderPostedorders");
    } else {
      setActiveTab("MyOrderPostedorders");
    }
  }, [urlstate, urlstate?.myorderroute]);

  const handleTabClick = (tab) => {
    resetAllFields();
    setActiveTab(tab);
    setMyOrderroute(tab);
  };

  return (
    <div className="order-section">
      <div className="tab-sec">
        <div className="order-first">
          <h2>My Orders</h2>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "MyOrderPostedorders" ? "active" : ""}`}
                onClick={() => handleTabClick("MyOrderPostedorders")}
              >
                Posted orders ({postedOrdersCount})
              </a>
            </li>
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "MyOrderPurchasedorders" ? "active" : ""}`}
                onClick={() => handleTabClick("MyOrderPurchasedorders")}
              >
                Purchased orders ({purchasedOrdersCount})
              </a>
            </li>
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "MyOrderCompleted" ? "active" : ""}`}
                onClick={() => handleTabClick("MyOrderCompleted")}
              >
                Completed ({completedOrdersCount})
              </a>
            </li>
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "MyOrderCancelled" ? "active" : ""}`}
                onClick={() => handleTabClick("MyOrderCancelled")}
              >
                Cancelled ({cancelledOrdersCount})
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "MyOrderPostedorders" ? "active" : ""}`}
            id="MyOrderPostedorders"
          >
            <PostedOrders postcounts={postcounts?.posted_orders} />
          </div>
          <div
            className={`tab-pane ${activeTab == "MyOrderPurchasedorders" ? "active" : ""}`}
            id="MyOrderPurchasedorders"
          >
            <PurchasedOrders postcounts={postcounts?.purchased_orders} />
          </div>
          <div
            className={`tab-pane ${activeTab == "MyOrderCompleted" ? "active" : ""}`}
            id="MyOrderCompleted"
          >
            <CompletedOrder postcounts={postcounts?.completed_orders} />
          </div>
          <div
            className={`tab-pane ${activeTab == "MyOrderCancelled" ? "active" : ""}`}
            id="MyOrderCancelled"
          >
            <CancelledOrder postcounts={postcounts?.cancelled_orders} />
          </div>
        </div>
      </div>
    </div>
  );
}
